import { LocalSeoHub } from '@/pages/local-seo/LocalLandingPages';

export default function KwiaciarniaOkoliceHub() {
  return <LocalSeoHub type="nearbyTown" />;
}